import { ExternalLinkIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { StyledLink } from 'baseui/link';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { useMatching } from '../../context';
import HintsCard from '../HintsCard';
import MatchingCard from '../MatchingCard';
import PartnerSelection from '../PartnerSelection';
export function MatchModal() {
  const matchCtx = useMatching();
  const [css] = useStyletron();
  return <Modal isOpen={matchCtx.matchHintModal.isVisible} size={'auto'} animate onClose={() => matchCtx.setMatchHintModal({
    isVisible: false
  })}>
      <ModalHeader>
        Match Project {matchCtx.matchHintModal.projectId}
      </ModalHeader>
      <ModalBody>
        <StyledLink href={`/admin/project/detail/${matchCtx.matchHintModal.projectId}`} target="_blank">
          View Project <ExternalLinkIcon />
        </StyledLink>
        <div className={css({
        display: 'flex',
        justifyContent: 'space-around'
      })}>
          <div className={css({
          margin: '20px',
          width: '34%'
        })}>
            <HintsCard title="Document Availability" />
          </div>
          <div className={css({
          margin: '20px',
          width: '33%'
        })}>
            <MatchingCard title="Partner Matching Hints" />
          </div>
          <div className={css({
          margin: '20px',
          width: '33%'
        })}>
            <PartnerSelection />
          </div>
        </div>
      </ModalBody>
    </Modal>;
}
export default MatchModal;